<ul ng-if="showMenu" class="menu">
    <li ng-repeat="menuitem in menuItems">
        <div ng-if="menuitem.divider" class="menu-divider"></div>
        <div ng-if="menuitem.radio" class="menu-item" ng-repeat="rdo in menuitem.items">
            <c-radiobutton name="menuitem.id" label="rdo.text" value="rdo.value" model="menuitem.selected" ng-click="menuClick($event, menuitem, rdo)"></c-radiobutton>
        </div>
        <div ng-if="menuitem.check" class="menu-item">
            <c-checkbox label="menuitem.text" checked="menuitem.selected" ng-click="menuClick($event, menuitem)"></c-checkbox>
        </div>
        <div ng-if="menuitem.menu" class="menu-item">
            <span class="text">{{ menuitem.text }}</span>
        </div>
        <div ng-if="menuitem.label" class="menu-label">
            {{ menuitem.text }}
        </div>
    </li>
</ul>
